import React from 'react';
import './About.css'

const About = () => {
    return (
        <div id='About' className='About-us'>

<div className='bg-secondary text-white'>
{/* <h1 className='bg-primary p-5'>About Us:</h1> */}

      <h1><u>Contact US</u></h1>
       <h3>Name:Md. Obaidur Rahman</h3>
       <h3>phone:01612897800</h3>
</div>

            

</div>
    );
};

export default About;